export const GST = 10;
export const FREE_TIER_DISCOUNT = 10; // percent

export const DEFAULT_CURRENCY = {
  name: 'AUD',
  scale_factor: 100,
};
